import { createContext } from 'react';
import { createShipmentContextType } from '../../types/shipment';

const CreateShipmentContext = createContext<createShipmentContextType | null>(null);

export default CreateShipmentContext;
